// extracted by mini-css-extract-plugin
export default {"m":"Payment_m__9B2wi","m_title":"Payment_m_title__IyAl9","mTitle":"Payment_m_title__IyAl9","m_c":"Payment_m_c__VHN59","mC":"Payment_m_c__VHN59","payment":"Payment_payment__ku7cU"};